/* You Fly LA kit (yk-) v66 :: yk-media.js :: built from kit/src */
/* --- 30-media-0-gallery.js --- */
/* =====================================================================
   KB3-MEDIA: shared photo stage (M.gal), lightbox (YK.lightbox), the
   yk-gallery element and the gallery + frames enhancers.
   Run once per page (window.YK_media.gallery). Never scrolls the page:
   every scroll is a contained scroller's own scrollLeft.
   ===================================================================== */
(function () {
  'use strict';
  var YK = window.YK;
  var M = window.YK_media = window.YK_media || {};
  if (!YK || M.gallery) return;
  M.gallery = 1;

  var qs = YK.qs, qsa = YK.qsa;
  var SVG = {
    prev: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>',
    full: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };
  M.svg = SVG;
  function behavior() { return YK.reduced() ? 'auto' : 'smooth'; }
  M.behavior = behavior;
  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  /* Lightbox item from an <img> (src/srcset/alt are read, never changed). */
  M.item = function (img, caption) {
    var fig = img.closest('figure');
    var cap = caption || (fig ? text(qs('figcaption', fig)) : '') || img.getAttribute('alt') || '';
    return { src: img.currentSrc || img.getAttribute('src') || '', srcset: img.getAttribute('srcset') || '', alt: img.getAttribute('alt') || '', caption: cap };
  };

  /* Keep a child visible inside its own horizontal scroller (no scrollIntoView). */
  M.reveal = function (scroller, child, smooth) {
    if (!scroller || !child) return;
    var sr = scroller.getBoundingClientRect(), cr = child.getBoundingClientRect();
    var sl = scroller.scrollLeft, w = scroller.clientWidth, to = sl;
    var l = cr.left - sr.left - scroller.clientLeft + sl, r = l + cr.width;
    if (l < sl) to = l - 4; else if (r > sl + w) to = r - w + 4;
    if (to !== sl) scroller.scrollTo({ left: Math.max(0, to), behavior: smooth ? behavior() : 'auto' });
  };

  /* ---------------------------------------------------------------- lightbox */
  var lb = null;
  function buildLb() {
    var d = document.createElement('dialog');
    d.className = 'yk yk-lb';
    d.setAttribute('aria-label', 'Photo Viewer');
    d.innerHTML =
      '<div class="yk-lb__bar"><span class="yk-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="yk-lb__btn" data-lb="close" aria-label="Close">' + SVG.close + '</button></div>' +
      '<div class="yk-lb__stage"><img class="yk-lb__img" alt="" decoding="async" draggable="false"></div>' +
      '<div class="yk-lb__foot"><p class="yk-lb__cap"></p><div class="yk-lb__nav">' +
      '<button type="button" class="yk-lb__btn" data-lb="prev" aria-label="Previous Photo">' + SVG.prev + '</button>' +
      '<button type="button" class="yk-lb__btn" data-lb="next" aria-label="Next Photo">' + SVG.next + '</button></div></div>';
    document.body.appendChild(d);
    var st = { d: d, img: qs('.yk-lb__img', d), cap: qs('.yk-lb__cap', d), count: qs('.yk-lb__count', d), stage: qs('.yk-lb__stage', d), items: [], i: 0, opener: null, overflow: '' };
    st.img.addEventListener('load', function () { st.img.classList.remove('is-loading'); });
    st.img.addEventListener('error', function () { st.img.classList.remove('is-loading'); });
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lb]');
      if (b) { var a = b.getAttribute('data-lb'); if (a === 'close') close(); else show(st.i + (a === 'next' ? 1 : -1)); return; }
      if (e.target === st.stage || e.target === d) close();
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(st.i + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(st.i - 1); }
      else if (e.key === 'Escape' && !d.showModal) { e.preventDefault(); close(); }
    });
    d.addEventListener('close', restore);
    d.addEventListener('cancel', function () { /* Escape: the dialog closes itself, 'close' restores */ });
    var x0 = null, y0 = 0;
    st.stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; });
    st.stage.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) show(st.i + (dx < 0 ? 1 : -1));
    });
    st.stage.addEventListener('pointercancel', function () { x0 = null; });
    lb = st;
    return st;
  }
  function show(i) {
    var st = lb, n = st.items.length;
    if (!n) return;
    st.i = ((i % n) + n) % n;
    var it = st.items[st.i] || {};
    if (!YK.reduced()) st.img.classList.add('is-loading');
    st.img.removeAttribute('srcset');
    st.img.setAttribute('sizes', '100vw');
    if (it.srcset) st.img.setAttribute('srcset', it.srcset);
    st.img.setAttribute('src', it.src || '');
    st.img.setAttribute('alt', it.alt || '');
    if (st.img.complete && st.img.naturalWidth) st.img.classList.remove('is-loading');
    st.cap.textContent = it.caption || it.alt || '';
    st.count.textContent = (st.i + 1) + ' / ' + n;
    st.d.classList.toggle('is-single', n < 2);
    [st.i + 1, st.i - 1].forEach(function (j) {   // warm the neighbours
      var nb = st.items[((j % n) + n) % n];
      if (nb && n > 1) { var p = new Image(); p.sizes = '100vw'; if (nb.srcset) p.srcset = nb.srcset; p.src = nb.src; }
    });
  }
  function restore() {
    var st = lb;
    if (!st) return;
    document.documentElement.style.overflow = st.overflow;
    st.d.classList.remove('is-fallback');
    if (st.opener && st.opener.focus && document.contains(st.opener)) { try { st.opener.focus({ preventScroll: true }); } catch (e) { st.opener.focus(); } }
    st.opener = null;
  }
  function close() {
    var st = lb;
    if (!st || !st.d.hasAttribute('open')) return;
    if (typeof st.d.close === 'function') st.d.close(); else { st.d.removeAttribute('open'); restore(); }
  }
  YK.lightbox = {
    /* items: [{src, srcset, alt, caption}], index: start, opener: element to refocus on close */
    open: function (items, index, opener) {
      if (!items || !items.length) return;
      var st = lb || buildLb();
      st.items = items.slice();
      st.opener = opener || document.activeElement;
      st.overflow = document.documentElement.style.overflow;
      show(index || 0);
      if (!st.d.hasAttribute('open')) {
        if (typeof st.d.showModal === 'function') st.d.showModal();
        else { st.d.setAttribute('open', ''); st.d.classList.add('is-fallback'); }
      }
      document.documentElement.style.overflow = 'hidden';
      var c = qs('[data-lb="close"]', st.d);
      if (c) { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }
      YK.track('lightbox', st.items[st.i] && st.items[st.i].alt);
    },
    close: close,
    isOpen: function () { return !!(lb && lb.d.hasAttribute('open')); }
  };

  /* ------------------------------------------------- shared stage (.yk-gal) */
  M.gal = function (root) {
    if (!root || root.__ykGal) return root && root.__ykGal;
    var stage = qs('.yk-gal__stage', root);
    if (!stage) return null;
    var slides = qsa('.yk-gal__slide', stage);
    var thumbs = qsa('.yk-gal__thumb', root);
    var thumbBox = qs('.yk-gal__thumbs', root);
    var count = qs('.yk-gal__count', root);
    var n = slides.length, i = 0, t = null;
    function width() { return stage.clientWidth || 0; }
    function warm(j) {   /* the next and previous slides start loading before they are swiped in */
      [j - 1, j, j + 1].forEach(function (k) {
        var s = slides[((k % n) + n) % n], im = s && qs('img', s);
        if (im && im.loading === 'lazy') im.loading = 'eager';
      });
    }
    function set(j, fromScroll) {
      i = j;
      warm(j);
      if (count) count.textContent = (i + 1) + ' / ' + n;
      thumbs.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      if (thumbs[i]) M.reveal(thumbBox, thumbs[i], !fromScroll);
    }
    var target = -1, tmo = null;
    function go(j, smooth) {
      if (!n) return;
      j = ((j % n) + n) % n;
      var w = width();
      /* one step glides; a jump (thumbnail, wrap-around) is instant, so it never flicks through every photo */
      var glide = smooth && Math.abs(j - i) === 1;
      if (w) {
        target = glide ? j : -1;
        clearTimeout(tmo);
        tmo = setTimeout(function () { target = -1; settle(); }, 1200);
        stage.scrollTo({ left: j * w, behavior: glide ? behavior() : 'auto' });
      }
      set(j, false);
    }
    function settle() {
      var w = width();
      if (!w) return;
      var j = Math.round(stage.scrollLeft / w);
      if (target >= 0) { if (j === target) target = -1; else return; }
      if (j !== i && j >= 0 && j < n) set(j, true);
    }
    function items() { return slides.map(function (s) { var im = qs('img', s); return im ? M.item(im) : null; }).filter(Boolean); }
    stage.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(settle, 80); }, { passive: true });
    stage.addEventListener('wheel', function () { target = -1; }, { passive: true });
    stage.addEventListener('touchstart', function () { target = -1; }, { passive: true });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1, true); }
      else if (e.key === 'Enter') { e.preventDefault(); YK.lightbox.open(items(), i, stage); }
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gal]');
      if (b && root.contains(b)) {
        var a = b.getAttribute('data-gal');
        if (a === 'prev') go(i - 1, true);
        else if (a === 'next') go(i + 1, true);
        else if (a === 'full') YK.lightbox.open(items(), i, b);
        return;
      }
      var th = e.target.closest('.yk-gal__thumb');
      if (th) { go(thumbs.indexOf(th), true); return; }
      var im = e.target.closest('.yk-gal__slide img');
      if (im && !im.closest('a[href]')) {
        var k = slides.indexOf(im.closest('.yk-gal__slide'));
        YK.lightbox.open(items(), k < 0 ? i : k, stage);
      }
    });
    root.addEventListener('pointerenter', function () { warm(i); }, { once: true });
    stage.addEventListener('focus', function () { warm(i); }, { once: true });
    stage.addEventListener('touchstart', function () { warm(i); }, { once: true, passive: true });
    var api = { go: go, sync: function () { var w = width(); if (w) stage.scrollLeft = i * w; }, index: function () { return i; }, size: n };
    window.addEventListener('resize', function () { api.sync(); }, { passive: true });
    root.__ykGal = api;
    if (n < 2) qsa('[data-gal="prev"],[data-gal="next"]', root).forEach(function (b) { b.hidden = true; });
    return api;
  };

  /* ---------------------------------------------------------- yk-gallery */
  YK.reg('gallery', function (el) {
    qsa('[data-yk-gal]', el).forEach(M.gal);
  });

  /* ------------------------------------------------------------ enhancers */
  function skip(node, box) {
    return !!node.closest('.yk, .yk-e-gallery, .yk-e-frame, table, [data-yk-skip]') || !box.contains(node);
  }
  function smallImg(img) {
    var w = parseInt(img.getAttribute('width'), 10);
    if (w && w < 200) return true;
    var r = img.getBoundingClientRect();
    return r.width > 0 && r.width < 160;
  }
  /* An "image block": a figure with one image (+ caption), a p/div holding only images, or a bare image. */
  function imgsOf(el) {
    if (el.tagName === 'IMG') return [el];
    if (!/^(FIGURE|P|DIV|A|PICTURE|SPAN)$/.test(el.tagName)) return null;
    var imgs = qsa('img', el);
    if (!imgs.length) return null;
    var clone = el.cloneNode(true);
    qsa('img, figcaption, br, picture source, script, style', clone).forEach(function (x) { x.parentNode.removeChild(x); });
    if (text(clone)) return null;
    if (qsa('table, ul, ol, h1, h2, h3, h4, h5, h6, iframe, video, form, button', el).length) return null;
    return imgs;
  }
  function blocks(box) {
    var out = [];
    qsa('img', box).forEach(function (img) {
      if (skip(img, box) || smallImg(img)) return;
      var el = img, best = img;
      while (el.parentElement && el.parentElement !== box) {
        var p = el.parentElement;
        var im = imgsOf(p);
        if (!im) break;
        best = p; el = p;
      }
      if (out.indexOf(best) < 0) out.push(best);
    });
    return out.map(function (b) { return { el: b, imgs: imgsOf(b) || [b] }; }).filter(function (b) { return b.imgs.length; });
  }
  function nextEl(el) {
    var n = el.nextSibling;
    while (n && ((n.nodeType === 3 && !n.textContent.trim()) || n.nodeType === 8 || (n.nodeType === 1 && n.tagName === 'BR'))) n = n.nextSibling;
    return n && n.nodeType === 1 ? n : null;
  }
  /* Runs of 2+ images: consecutive image blocks, or one block with 2+ images. */
  M.runs = function (box) {
    var bl = blocks(box), runs = [], cur = null;
    bl.forEach(function (b) {
      if (cur && nextEl(cur[cur.length - 1].el) === b.el) cur.push(b);
      else { cur = [b]; runs.push(cur); }
    });
    return runs.filter(function (r) { return r.reduce(function (a, b) { return a + b.imgs.length; }, 0) >= 2; });
  };

  YK.enh('gallery', function (box) {
    M.runs(box).forEach(function (run) {
      var wrap = document.createElement('div');
      wrap.className = 'yk yk-e-gallery yk-ready';
      var imgs = [];
      run.forEach(function (b) { b.imgs.forEach(function (im) { imgs.push({ img: im, block: b }); }); });
      var n = imgs.length;
      wrap.innerHTML = '<div class="yk-gal" data-yk-gal><div class="yk-gal__viewer"><div class="yk-gal__stage" data-yk-scroll tabindex="0" role="region" aria-roledescription="Carousel" aria-label="Photos, Use The Arrow Keys"></div>' +
        '<div class="yk-gal__ui"><span class="yk-gal__cap"><span class="yk-gal__count" aria-live="polite">1 / ' + n + '</span></span><span class="yk-gal__btns">' +
        '<button type="button" class="yk-gal__btn" data-gal="prev" aria-label="Previous Photo">' + SVG.prev + '</button>' +
        '<button type="button" class="yk-gal__btn" data-gal="next" aria-label="Next Photo">' + SVG.next + '</button>' +
        '<button type="button" class="yk-gal__btn" data-gal="full" aria-label="View Full Screen">' + SVG.full + '</button></span></div></div>' +
        '<div class="yk-gal__thumbs" data-yk-scroll></div></div>';
      var stage = qs('.yk-gal__stage', wrap), th = qs('.yk-gal__thumbs', wrap);
      var first = run[0].el;
      first.parentNode.insertBefore(wrap, first);
      imgs.forEach(function (o, k) {
        var slide = document.createElement('div');
        slide.className = 'yk-gal__slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'Slide');
        slide.setAttribute('aria-label', (k + 1) + ' Of ' + n);
        var w = +o.img.getAttribute('width'), h = +o.img.getAttribute('height');
        if (w && h && h > w) slide.className += ' is-port';
        /* move (never remove) the original block; a block with several images moves image by image */
        var mover = o.block.imgs.length > 1 ? (o.img.parentElement && o.img.parentElement.tagName === 'A' && o.img.parentElement.children.length === 1 ? o.img.parentElement : o.img) : o.block.el;
        slide.appendChild(mover);
        stage.appendChild(slide);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'yk-gal__thumb';
        b.setAttribute('aria-label', 'Show Photo ' + (k + 1) + ' Of ' + n);
        if (!k) b.setAttribute('aria-current', 'true');
        var c = document.createElement('img');
        c.alt = ''; c.loading = 'lazy'; c.decoding = 'async';
        c.src = o.img.currentSrc || o.img.getAttribute('src');
        th.appendChild(b); b.appendChild(c);
      });
      M.gal(qs('[data-yk-gal]', wrap));
    });
  });

  YK.enh('frames', function (box) {
    var galleryOn = /(^|[\s,])gallery([\s,]|$)/.test(box.getAttribute('data-yk-enhance') || '');
    var inRun = [];
    if (galleryOn) M.runs(box).forEach(function (r) { r.forEach(function (b) { inRun = inRun.concat(b.imgs); }); });
    qsa('img', box).forEach(function (img) {
      if (skip(img, box) || smallImg(img) || inRun.indexOf(img) >= 0) return;
      var a = img.parentElement && img.parentElement.tagName === 'A' && img.parentElement.children.length === 1 ? img.parentElement : null;
      var target = a || img;
      var frame = document.createElement('span');
      frame.className = 'yk-e-frame';
      target.parentNode.insertBefore(frame, target);
      frame.appendChild(target);             /* moved, not removed: src/alt untouched */
      var alt = img.getAttribute('alt') || '';
      var fig = img.closest('figure');
      var hasCap = fig && box.contains(fig) && qs('figcaption', fig);
      if (fig && box.contains(fig)) fig.classList.add('yk-e-fig');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'yk-e-frame__btn';
      btn.setAttribute('aria-label', 'View Full Screen' + (alt ? ': ' + alt : ''));
      btn.innerHTML = SVG.full;
      frame.appendChild(btn);
      if (!hasCap && alt && alt.length <= 140) {
        var cap = document.createElement('span');
        cap.className = 'yk-e-frame__cap';
        cap.setAttribute('aria-hidden', 'true');   /* the alt already speaks for the image */
        cap.textContent = alt;
        frame.appendChild(cap);
      }
      var open = function () { YK.lightbox.open([M.item(img)], 0, btn); };
      btn.addEventListener('click', open);
      if (!a) img.addEventListener('click', open);
    });
  });
})();

/* --- 30-media-attitude.js --- */
/* =====================================================================
   KB3-MEDIA: yk-attitude (design 01). Drag (pointer) or arrow keys to
   bank and pitch; readout in the panel bar; eases back to level on
   release (reduced motion: snaps). Stat tiles highlight their phrase.
   ===================================================================== */
(function () {
  'use strict';
  var YK = window.YK;
  var M = window.YK_media = window.YK_media || {};
  if (!YK || M.attitude) return;
  M.attitude = 1;
  var qs = YK.qs, qsa = YK.qsa;
  var MAXB = 60, MAXP = 20;

  YK.reg('attitude', function (el) {
    var adi = qs('.yk-att__adi', el);
    if (adi) instrument(el, adi);
    tiles(el);
  });

  function instrument(el, adi) {
    var ball = qs('[data-adi="ball"]', adi), scale = qs('[data-adi="scale"]', adi);
    var ro = qs('.yk-att__ro', el), live = qs('.yk-att__live', el);
    var bank = 0, pitch = 0, drag = null, raf = 0, idle = 0, say = 0;
    function p2(v) { v = Math.round(Math.abs(v)); return (v < 10 ? '0' : '') + v; }
    function label(spoken) {
      var b = bank < -0.5 ? (spoken ? ' Left' : ' L') : bank > 0.5 ? (spoken ? ' Right' : ' R') : '';
      var p = pitch < -0.5 ? (spoken ? ' Down' : ' Dn') : pitch > 0.5 ? ' Up' : '';
      return 'Bank ' + p2(bank) + '°' + b + ' · Pitch ' + p2(pitch) + '°' + p;
    }
    function draw() {
      if (ball) ball.setAttribute('transform', 'rotate(' + (-bank).toFixed(2) + ' 150 150) translate(0 ' + (pitch * 4).toFixed(2) + ')');
      if (scale) scale.setAttribute('transform', 'rotate(' + (-bank).toFixed(2) + ' 150 150)');
      if (ro) ro.textContent = label(false);
    }
    function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; }
    function level() {
      stop();
      if (YK.reduced()) { bank = 0; pitch = 0; draw(); return; }
      var t0 = performance.now(), b0 = bank, q0 = pitch;
      (function step(t) {
        var k = Math.min(1, (t - t0) / 600), e = 1 - Math.pow(1 - k, 3);
        bank = b0 * (1 - e); pitch = q0 * (1 - e); draw();
        raf = k < 1 && !drag ? requestAnimationFrame(step) : 0;
      })(t0);
    }
    adi.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button > 0) return;
      stop(); clearTimeout(idle);
      drag = { x: e.clientX, y: e.clientY, b: bank, p: pitch };
      adi.classList.add('is-drag', 'is-used');
      try { adi.setPointerCapture(e.pointerId); } catch (x) { /* no-op */ }
      e.preventDefault();
    });
    adi.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var r = adi.getBoundingClientRect();
      bank = YK.clamp(drag.b + (e.clientX - drag.x) / (r.width || 1) * 120, -MAXB, MAXB);
      pitch = YK.clamp(drag.p + (drag.y - e.clientY) / (r.height || 1) * 50, -MAXP, MAXP);
      draw();
    });
    function end() { if (!drag) return; drag = null; adi.classList.remove('is-drag'); level(); }
    adi.addEventListener('pointerup', end);
    adi.addEventListener('pointercancel', end);
    adi.addEventListener('lostpointercapture', end);
    adi.addEventListener('keydown', function (e) {
      var used = true;
      if (e.key === 'ArrowLeft') bank -= 5;
      else if (e.key === 'ArrowRight') bank += 5;
      else if (e.key === 'ArrowUp') pitch += 2;
      else if (e.key === 'ArrowDown') pitch -= 2;
      else if (e.key === 'Home' || e.key === 'Escape' || e.key === '0') { bank = 0; pitch = 0; }
      else used = false;
      if (!used) return;
      e.preventDefault();
      stop();
      bank = YK.clamp(bank, -MAXB, MAXB); pitch = YK.clamp(pitch, -MAXP, MAXP);
      adi.classList.add('is-used');
      draw();
      clearTimeout(say); say = setTimeout(function () { if (live) live.textContent = label(true); }, 350);
      clearTimeout(idle); idle = setTimeout(level, 1500);
    });
    adi.addEventListener('blur', function () { clearTimeout(idle); if (!drag && (bank || pitch)) level(); });
    draw();
  }

  function tiles(el) {
    var ts = qsa('.yk-att__tile', el), marks = qsa('.yk-att__mark', el), pinned = null;
    function show(h) {
      ts.forEach(function (t) { t.classList.toggle('is-on', !!h && t.getAttribute('data-hl') === h); });
      marks.forEach(function (m) { m.classList.toggle('is-on', !!h && m.getAttribute('data-hl') === h); });
    }
    ts.forEach(function (t) {
      var h = t.getAttribute('data-hl');
      t.addEventListener('click', function () {
        pinned = pinned === h ? null : h;
        ts.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-hl') === pinned ? 'true' : 'false'); });
        show(pinned);
      });
      t.addEventListener('mouseenter', function () { show(h); });
      t.addEventListener('mouseleave', function () { show(pinned); });
      t.addEventListener('focus', function () { show(h); });
      t.addEventListener('blur', function () { show(pinned); });
    });
  }
})();

/* --- 30-media-filmstrip.js --- */
/* =====================================================================
   KB3-MEDIA: yk-filmstrip. Counter + progress line + prev/next for a
   contained scroll-snap row; aerial photos open the shared lightbox.
   Only the row's own scrollLeft ever moves (never the page).
   ===================================================================== */
(function () {
  'use strict';
  var YK = window.YK;
  var M = window.YK_media = window.YK_media || {};
  if (!YK || M.filmstrip) return;
  M.filmstrip = 1;
  var qs = YK.qs, qsa = YK.qsa;
  function two(n) { return (n < 10 ? '0' : '') + n; }

  YK.reg('filmstrip', function (el, o) {
    var track = qs('.yk-film__track', el);
    if (!track) return;
    var items = qsa('.yk-film__item', track), n = items.length, i = 0, t = null, hold = -1, ht = null;
    var num = qs('.yk-film__num', el) || qs('.yk-film__count', el);
    var line = qs('.yk-film__line i', el);
    var pad = o.fmt === 'pad';
    if (line) line.style.setProperty('--yk-seg', (100 / Math.max(1, n)) + '%');
    function pos(k) {
      var tr = track.getBoundingClientRect(), r = items[k].getBoundingClientRect();
      return r.left - tr.left - track.clientLeft + track.scrollLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    }
    function set(k) {
      i = k;
      if (num) num.textContent = pad ? two(k + 1) + ' / ' + two(n) : (k + 1) + ' / ' + n;
      if (line) line.style.setProperty('--yk-pos', k);
    }
    function go(k) {
      if (!n) return;
      k = ((k % n) + n) % n;
      var max = track.scrollWidth - track.clientWidth;
      var glide = Math.abs(k - i) === 1 && M.behavior;   /* wrap-around jumps instantly */
      track.scrollTo({ left: Math.max(0, Math.min(max, pos(k))), behavior: glide ? M.behavior() : 'auto' });
      hold = k; clearTimeout(ht); ht = setTimeout(function () { hold = -1; }, 1200);
      set(k);
    }
    function nearest() {
      var max = track.scrollWidth - track.clientWidth;
      if (max > 0 && track.scrollLeft >= max - 2) return n - 1;
      var best = 0, bd = 1e9;
      for (var k = 0; k < n; k++) { var d = Math.abs(pos(k) - track.scrollLeft); if (d < bd) { bd = d; best = k; } }
      return best;
    }
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (hold >= 0) {   /* a button/key scroll is still gliding: keep the index it set */
          var max = track.scrollWidth - track.clientWidth, dest = Math.max(0, Math.min(max, pos(hold)));
          if (Math.abs(track.scrollLeft - dest) < 3) hold = -1;
          return;
        }
        var k = nearest();
        if (k !== i) set(k);
      }, 80);
    }, { passive: true });
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-film]');
      if (b && el.contains(b)) { go(i + (b.getAttribute('data-film') === 'next' ? 1 : -1)); return; }
      var im = e.target.closest('.yk-film__fig img');
      if (im && YK.lightbox) {
        var imgs = qsa('.yk-film__fig img', track);
        YK.lightbox.open(imgs.map(function (x) { return M.item(x); }), imgs.indexOf(im), im);
      }
    });
    track.addEventListener('wheel', function () { hold = -1; }, { passive: true });
    track.addEventListener('touchstart', function () { hold = -1; }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(n - 1, i + 1)); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); }
      else if (e.key === 'End') { e.preventDefault(); go(n - 1); }
    });
    set(0);
  });
})();

/* --- 30-media-fleet.js --- */
/* =====================================================================
   KB3-MEDIA: yk-fleet. ARIA tabs (arrow keys, Home/End) over panels that
   are all pre-rendered (the focus panel shown, others [hidden]); each
   panel's photo stage is the shared M.gal (swipe, thumbs, lightbox).
   ===================================================================== */
(function () {
  'use strict';
  var YK = window.YK;
  var M = window.YK_media = window.YK_media || {};
  if (!YK || M.fleet) return;
  M.fleet = 1;
  var qs = YK.qs, qsa = YK.qsa;

  YK.reg('fleet', function (el) {
    var list = qs('[role="tablist"]', el);
    if (!list) return;
    var tabs = qsa('[role="tab"]', list);
    var gals = {};
    qsa('[role="tabpanel"]', el).forEach(function (p) {
      var g = qs('[data-yk-gal]', p);
      if (g && M.gal) gals[p.id] = M.gal(g);
    });
    function panel(t) { var id = t.getAttribute('aria-controls'); return id ? document.getElementById(id) : null; }
    function select(t, focus, smooth) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = panel(x);
        if (p) p.hidden = !on;
      });
      var g = gals[t.getAttribute('aria-controls')];
      if (g) g.sync();
      if (M.reveal) M.reveal(list, t, smooth);
      if (focus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
      YK.track('fleet_tab', t.getAttribute('data-key'));
    }
    list.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t && list.contains(t)) select(t, false, true);
    });
    list.addEventListener('keydown', function (e) {
      var k = tabs.indexOf(document.activeElement);
      if (k < 0) return;
      var j = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (k + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (k - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = tabs.length - 1;
      if (j === null) return;
      e.preventDefault();
      select(tabs[j], true, true);
    });
    var cur = qs('[aria-selected="true"]', list) || tabs[0];
    if (cur && M.reveal) M.reveal(list, cur, false);
  });
})();
